var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wysiwyg-editor-wrapper",
      class: {
        "is-dragover": _vm.isDragover,
        "is-focused": _vm.isFocused,
        "is-disabled": _vm.disabled,
        "mode-description": _vm.mode === "description",
      },
      style: _vm.minHeight ? { "--wysiwyg-min-height": _vm.minHeight } : null,
      on: {
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.handleDragOver.apply(null, arguments)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.handleDragLeave.apply(null, arguments)
        },
        drop: function ($event) {
          $event.preventDefault()
          return _vm.handleDrop.apply(null, arguments)
        },
      },
    },
    [
      _c("editor-content", {
        staticClass: "wysiwyg-editor-container",
        attrs: { editor: _vm.editor },
      }),
      _vm._v(" "),
      _vm.attachedFiles.length > 0
        ? _c(
            "div",
            { staticClass: "attached-files-preview" },
            _vm._l(_vm.attachedFiles, function (file, index) {
              return _c(
                "div",
                {
                  key: file.id,
                  staticClass: "attached-file-item is-document",
                  on: {
                    click: function ($event) {
                      return _vm.previewFile(file)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "attached-file-icon",
                    class: file.icon,
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "attached-file-name" }, [
                    _vm._v(_vm._s(file.name)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "attached-file-remove",
                      attrs: { type: "button", title: "Rimuovi" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.removeAttachedFile(index)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-times" })]
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "wysiwyg-bottom-toolbar" }, [
        _c("div", { staticClass: "toolbar-actions" }, [
          _c(
            "button",
            {
              staticClass: "toolbar-icon-btn",
              class: { "is-active": _vm.isActive("bold") },
              attrs: { type: "button", title: "Grassetto (Cmd+B)" },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.formatBold.apply(null, arguments)
                },
              },
            },
            [_c("strong", [_vm._v("B")])]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toolbar-icon-btn",
              class: { "is-active": _vm.isActive("italic") },
              attrs: { type: "button", title: "Corsivo (Cmd+I)" },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.formatItalic.apply(null, arguments)
                },
              },
            },
            [_c("em", [_vm._v("I")])]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toolbar-icon-btn",
              class: { "is-active": _vm.isActive("underline") },
              attrs: { type: "button", title: "Sottolineato (Cmd+U)" },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.formatUnderline.apply(null, arguments)
                },
              },
            },
            [_c("u", [_vm._v("U")])]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toolbar-icon-btn",
              class: { "is-active": _vm.isActive("strike") },
              attrs: { type: "button", title: "Barrato" },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.formatStrike.apply(null, arguments)
                },
              },
            },
            [_c("s", [_vm._v("S")])]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "toolbar-sep" }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toolbar-icon-btn",
              class: { "is-active": _vm.isActive("bulletList") },
              attrs: { type: "button", title: "Elenco puntato" },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.formatBulletList.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "fa fa-list-ul" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toolbar-icon-btn",
              class: { "is-active": _vm.isActive("orderedList") },
              attrs: { type: "button", title: "Elenco numerato" },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.formatOrderedList.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "fa fa-list-ol" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toolbar-icon-btn",
              class: { "is-active": _vm.isActive("taskList") },
              attrs: { type: "button", title: "Checklist" },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.formatTaskList.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "fa fa-check-square-o" })]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "toolbar-sep" }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toolbar-icon-btn",
              class: { "is-active": _vm.isActive("blockquote") },
              attrs: { type: "button", title: "Citazione" },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.formatBlockquote.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "fa fa-quote-left" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toolbar-icon-btn",
              class: { "is-active": _vm.isActive("codeBlock") },
              attrs: { type: "button", title: "Blocco codice" },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.formatCodeBlock.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "fa fa-code" })]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "toolbar-sep" }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toolbar-icon-btn",
              class: { "is-active": _vm.isActive("link") },
              attrs: { type: "button", title: "Inserisci link" },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.insertLink.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "fa fa-link" })]
          ),
          _vm._v(" "),
          _vm.taskId
            ? _c(
                "button",
                {
                  staticClass: "toolbar-icon-btn",
                  attrs: { type: "button", title: "Allega file" },
                  on: {
                    mousedown: function ($event) {
                      $event.preventDefault()
                      return _vm.triggerFileUpload.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-paperclip" })]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        staticStyle: { display: "none" },
        attrs: {
          type: "file",
          multiple: "",
          accept:
            ".pdf,.doc,.docx,.odt,.rtf,.xls,.xlsx,.ods,.csv,.tsv,.ppt,.pptx,.odp,.jpg,.jpeg,.png,.gif,.webp,.svg,.mp4,.mov,.avi,.mkv,.webm,.txt,.md,.json,.xml,.yml,.yaml,.zip,.rar,.7z,.tar,.gz,.tgz",
        },
        on: { change: _vm.handleFileSelect },
      }),
      _vm._v(" "),
      _vm.isDragover
        ? _c("div", { staticClass: "drag-overlay" }, [
            _c("i", { staticClass: "fa fa-cloud-upload" }),
            _vm._v(" "),
            _c("span", [_vm._v("Rilascia per allegare")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.uploadProgress.active
        ? _c("div", { staticClass: "upload-indicator" }, [
            _c("i", { staticClass: "fa fa-spinner fa-spin" }),
            _vm._v(" "),
            _vm.uploadProgress.total > 1
              ? _c("span", [
                  _vm._v(
                    "Caricamento " +
                      _vm._s(_vm.uploadProgress.done) +
                      "/" +
                      _vm._s(_vm.uploadProgress.total) +
                      "..."
                  ),
                ])
              : _c("span", [_vm._v("Caricamento...")]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }